import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-circle-o-notch fa-spin fa-5x fa-fw" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Loading...", -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingModal',
  props: {
  visible: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_CModal = _resolveComponent("CModal")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
    _createVNode(_component_CModal, {
      backdrop: "static",
      "content-class-name": "align-items-center bg-transparent p-4 shadow-none border-0",
      visible: __props.visible,
      alignment: "center"
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ], undefined, true),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})